import styles from './image-subtitle.module.scss';

export type ImageSubtitleProps = {
  src: string;
  subtitle?: string;
};

const ImageSubtitle = ({ src, subtitle }: ImageSubtitleProps) => (
  <div className={styles.container}>
    <img src={src} className={styles.image} />
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
  </div>
);

export default ImageSubtitle;
